<template>
  <section class="test-ride bg-[#393939]">
    <!-- Desktop version Banner cover Section -->
    <div
      class="relative md:block hidden w-full overflow-hidden md:bg-center bg-no-repeat bg-right md:bg-contain test-drive-hero-bg-section h-[632px] lg:h-[742px] 2xl:h-[820px] xl:block"
    >
      <div class="h-[480px] md:h-[497px] lg:h-[560px] xl:h-[740px]">
        <div class="container md:relative absolute top-[130px] lg:top-[164px]">
          <div
            class="border-b-4 ml-0.5 md:border-b-[6px] skew-x-[-25deg] w-[106px]"
            style="border-color: #f54308"
          />
          <h1
            class="text-[32px] md:text-5xl uppercase flex xl:text-[58px] italic font-ff-good-pro-cond font-medium xl:tracking-normal leading-[38px] md:leading-[3rem] xl:leading-[60px] text-start text-white mt-6 xl:mt-[41px] mb-0"
          >
            {{ $t("common.test_title") }} &nbsp;
            <span class="lowercase text-primary">
              {{ $t("common.drive") }}
            </span>
          </h1>
          <p
            class="text-[15px] brand-name-style md:text-[18px] w-[299px] md:w-[450px] lg:w-[540px] font-ff-good-pro-cond leading-[24px] font-normal text-start text-white pt-[12px] md:pt-[24px]"
            v-html="
              $t('common.test_drive_description', {
                brand_name: 'Keeway ',
                interpolation: { prefix: '[:', suffix: ']' },
              })
            "
          ></p>
        </div>
      </div>
    </div>

    <!-- Mobile Version Banner cover Section-->
    <div class="block lg:hidden md:hidden">
      <div class="relative" data-aos="fade-left" data-aos-delay="100">
        <img
          class="relative w-full h-[480px] object-cover object-center"
          src="@/assets/images/test-drive/test-drive-mobile-banner-img.png"
          alt=""
        />
      </div>

      <div
        class="flex bg-[#393939] items-center justify-start order-2 px-[15px] pt-[40px] md:py-[60px] overflow-hidden md:w-1/2"
      >
        <div class="w-auto">
          <div
            class="border-b-4 w-[67px] border-primary skew-x-[-25deg] flex justify-start items-start text-start h-1 lg:h-[6px] mb-[16px]"
          />
          <h1
            class="text-[34px] font-ff-good-pro-cond font-medium italic heading-text w-[345px] sm:w-full leading-[38px] text-start text-white"
          >
            {{ $t("common.test_title") }}
            <span class="lowercase text-primary">
              {{ $t("common.drive") }}
            </span>
          </h1>
          <p
            class="text-[15px] xl:text-[20px] xl:leading-normal mt-[10px] text-white leading-[24px] font-ff-good-pro-cond font-normal"
            v-html="
              $t('common.test_drive_description', {
                brand_name: 'Keeway ',
                interpolation: { prefix: '[:', suffix: ']' },
              })
            "
          ></p>
        </div>
      </div>
    </div>

    <div class="container pt-[60px] pb-[60px] md:py-20">
      <div class="b-10">
        <div class="lg:grid lg:grid-cols-3 lg:gap-8">
          <h2
            class="text-[22px] text-white font-ff-good-pro-cond text-center md:text-left font-normal sm:text-[28px] sm:leading-[32px]"
            v-text="$t('common.test_ride_inquiry.registration')"
          />
          <form
            id="test_ride_form"
            action="#"
            method="POST"
            class="grid grid-cols-1 col-span-2 mt-6 gap-y-[28px] sm:grid-cols-2 sm:gap-x-8 lg:mt-0"
            @submit.prevent="onSubmit"
          >
            <div class="sm:col-span-2">
              <label
                for="test_drive_name"
                class="block text-[10px] font-bold font-ff-good-pro-cond text-white leading-[20px] uppercase"
                v-text="$t('common.given_name')"
              />
              <div class="mt-1">
                <input
                  id="test_drive_name"
                  v-model="form.name"
                  data-cons-subject="name"
                  type="text"
                  name="name"
                  autocomplete="name"
                  :placeholder="$t('common.placeholder')"
                  class="block w-full px-4 py-3 rounded-lg bg-[#FFFFFF] placeholder:text-sm placeholder:font-ff-good-pro-cond bg-opacity-10 shadow-sm text-white focus:border-primary focus:ring-0"
                  :class="{ 'is-invalid': errorsObj && errorsObj.name }"
                  @input="clearValidation('name')"
                />
                <p
                  v-if="errorsObj && errorsObj.name"
                  class="mt-1 text-sm text-red-400"
                  v-text="errorsObj.name[0]"
                />
              </div>
            </div>
            <div class="sm:col-span-2">
              <label
                for="test_drive_phone_number"
                class="block text-[10px] font-bold font-ff-good-pro-cond text-white leading-[20px] uppercase"
                v-text="$t('common.phone')"
              />
              <div class="relative mt-1 rounded-md shadow-sm">
                <client-only>
                  <VueTelInput
                    id="phone"
                    v-model="form.phone"
                    input-id="test_drive_phone_number"
                    mode="international"
                    autocomplete="phone"
                    :default-country="store.country"
                    :class="[
                      'text-white  phone',
                      { 'is-invalid': errorsObj && errorsObj.phone },
                    ]"
                    :input-options="options"
                    @input="clearValidation('phone')"
                    @open="isDropdownOpen = true"
                    @close="isDropdownOpen = false"
                  >
                    <template #arrow-icon>
                      <ArrowDownSLineIcon
                        class="w-5 h-5 text-white transition-transform transform"
                        :class="isDropdownOpen ? 'rotate-180' : ''"
                      />
                    </template>
                  </VueTelInput>
                </client-only>
                <p
                  v-if="errorsObj && errorsObj.phone"
                  class="mt-1 text-sm text-red-400"
                  v-text="errorsObj.phone[0]"
                />
              </div>
            </div>
            <div class="sm:col-span-2">
              <label
                for="test_drive_email"
                class="block text-[10px] font-bold font-ff-good-pro-cond text-white leading-[20px] uppercase"
                v-text="$t('common.email')"
              />
              <div class="mt-1">
                <input
                  id="test_drive_email"
                  v-model="form.email"
                  data-cons-subject="email"
                  name="email"
                  type="email"
                  :placeholder="$t('common.placeholder')"
                  autocomplete="email"
                  class="block w-full px-4 py-3 rounded-lg bg-[#FFFFFF] placeholder:text-sm placeholder:font-ff-good-pro-cond bg-opacity-10 shadow-sm text-white focus:border-primary focus:ring-0"
                  :class="{ 'is-invalid': errorsObj && errorsObj.email }"
                  @input="clearValidation('email')"
                />
                <p
                  v-if="errorsObj && errorsObj.email"
                  class="mt-1 text-sm text-red-400"
                  v-text="errorsObj.email[0]"
                />
              </div>
            </div>
            <div class="sm:col-span-2">
              <label
                for="bike"
                class="block text-[10px] font-bold font-ff-good-pro-cond text-white leading-[20px] uppercase"
                v-text="$t('common.test_ride_inquiry.model_you_want_to_drive')"
              />
              <div class="mt-1">
                <select
                  id="test_drive_subject"
                  v-model="selected"
                  type="text"
                  :placeholder="$t('common.placeholder')"
                  name="subject"
                  class="block w-full px-4 py-3 text-white text-sm rounded-lg bg-[#FFFFFF] placeholder:text-sm placeholder:text-opacity-70 placeholder:font-ff-good-pro-cond bg-opacity-10 shadow-sm focus:border-primary focus:ring-0"
                  :class="[
                    errorsObj && errorsObj.product_id ? 'is-invalid' : '',
                    selected ? '' : 'text-opacity-70',
                  ]"
                  @input="clearValidation('product_id')"
                >
                  <option
                    disabled
                    value=""
                    selected
                    class="text-white text-opacity-40"
                  >
                    {{ $t("common.placeholder") }}
                  </option>
                  <option
                    v-for="(product, productIndex) in products"
                    :key="productIndex"
                    :value="product"
                    v-text="product.name"
                  />
                </select>
                <p
                  v-if="errorsObj && errorsObj.product_id"
                  class="mt-1 text-sm text-red-400"
                  v-text="errorsObj.product_id[0]"
                />
              </div>
            </div>
            <div class="sm:col-span-2">
              <label
                for="other_information"
                class="block text-[10px] font-bold font-ff-good-pro-cond text-white leading-[20px] uppercase"
                v-text="$t('common.test_ride_inquiry.other_information')"
              />
              <div class="relative mt-1">
                <textarea
                  id="other_information"
                  v-model="form.message"
                  :placeholder="$t('common.placeholder')"
                  name="message"
                  rows="4"
                  class="block w-full px-4 py-3 border rounded-lg bg-[#FFFFFF] placeholder:text-sm placeholder:font-ff-good-pro-cond bg-opacity-[0.06] shadow-sm min-h-40 text-white lg:min-h-32 max-h-64 focus:border-primary focus:ring-0"
                  :class="{ 'is-invalid': errorsObj && errorsObj.message }"
                  @input="clearValidation('message')"
                />
                <p
                  v-if="errorsObj && errorsObj.message"
                  class="mt-1 text-sm text-red-400"
                  v-text="errorsObj.message[0]"
                />
              </div>
            </div>
            <div class="sm:col-span-2">
              <label
                class="w-full text-lg text-white border border-transparent cursor-pointer test-drive--checkbox"
                :class="{
                  'border-red-500 p-1 rounded-md':
                    errorsObj && errorsObj.accept_terms,
                }"
              >
                <input
                  id="test_drive_tos"
                  v-model="form.accept_terms"
                  type="checkbox"
                  class="me-3 cursor-pointer relative text-primary placeholder:text-sm placeholder:font-ff-good-pro-cond bg-transparent border-primary rounded focus:ring-primary-500 focus:ring-2 mb-[.1rem]"
                  data-cons-preference="terms-and-conditions"
                  @input="clearValidation('accept_terms')"
                />
                <span
                  ref="link"
                  class="text-sm font-normal leading-[28px] text-white terms test_drive__checkmark font-ff-good-pro-cond"
                  v-html="
                    $t('common.test_ride_inquiry.accept_data_management_info')
                      .replace('legal', 'javascript:void(0)')
                      .replace(
                        'privacy-policy',
                        policyData ? 'privacy-policy' : 'privacy-policy-remove'
                      )
                  "
                />
              </label>
              <p
                v-if="errorsObj && errorsObj.accept_terms"
                class="mt-1 text-sm text-red-400"
                v-text="errorsObj.accept_terms[0]"
              />
            </div>
            <div class="justify-center hidden md:justify-start">
              <vue-hcaptcha
                ref="invisibleHcaptcha"
                size="invisible"
                :sitekey="$config.HCAPTCHA_SITE_KEY"
                theme="light"
                :language="store.locale"
                @verify="onVerify"
                @expired="onExpire"
                @challengeExpired="onExpire"
                @closed="onExpire"
                @error="onError"
              />
            </div>

            <div class="sm:col-span-2">
              <Btn
                id="test_drive_submit"
                type="submit"
                size="xl"
                block
                class="uppercase bg-primary py-[11px] px-0 md:px-[22px] md:py-[12px] border-none !rounded-[10px]"
                color=""
                :disabled="sending"
              >
                <div class="flex items-center justify-center space-x-2">
                  <Spinner v-if="sending" class="text-white animate-spin" />
                  <span
                    class="text-sm font-semibold font-ff-good-pro-cond text-white leading-[26px] uppercase"
                  >
                    {{ $t("common.submit") }}</span
                  >
                </div>
              </Btn>
            </div>
          </form>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { VueTelInput } from "vue-tel-input";
import VueHcaptcha from "@hcaptcha/vue3-hcaptcha";
import PrivacyPolicyTestDriveModal from "~/modals/PrivacyPolicyTestDriveModal";
import ArrowDownSLineIcon from "@/assets/svg/heroicons/arrow-down-s-line.svg?component";
import { useModal } from "vue-final-modal";
import { useTranslation } from "i18next-vue";
import { useMainStore } from "@/store/index";
import { useLocaleStore } from "@/store/locales";

const formFields = {
  name: "",
  email: "",
  phone: "",
  product_id: null,
  message: "",
  accept_terms: "",
};

const nuxtApp = useNuxtApp();
const { t } = useTranslation();
const store = useMainStore();
const localeStore = useLocaleStore();
const $config = useRuntimeConfig().public;

const products = ref([]);
const testDrivePageContent = ref(null);
const policyData = ref(null);
const invisibleHcaptcha = ref(null);
const intercom = ref(
  typeof nuxtApp.$intercom !== "undefined" ? nuxtApp.$intercom : null
);
const selected = ref("");
const subjects = ref(["general_enquiry", "marketing_and_sales"]);
const form = reactive(Object.assign({}, formFields));
const sending = ref(false);
let errorsObj = ref(null);
const link = ref(null);
const searchQuery = ref(null);
const isDropdownOpen = ref(false);
const options = reactive({
  placeholder: t("common.phone_number_placeholder"),
});

let policyResData, testRideData, productsData;
try {
  productsData = await useAPI("api/front/products?test-ride-inquiry=true");

  products.value = productsData.data._rawValue;
} catch (e) {
  testRideData.value = null;
  policyData.value = null;
  throw createError({
    statusCode: 404,
    statusMessage: "Page Not Found",
  });
}
try {
  testRideData = await useAPI("api/front/pages/test-ride-inquiry");

  testDrivePageContent.value =
    testRideData && testRideData.data && testRideData.data._rawValue.data;
} catch (e) {
  testRideData.value = null;
}
try {
  policyResData = await useAPI("api/front/pages/test-ride-policy");

  policyData.value =
    policyResData && policyResData.data && policyResData.data._rawValue.data;
} catch (e) {
  policyData.value = null;
}

onMounted(() => {
  if (link.value && link.value.firstElementChild && policyData.value) {
    link.value.firstElementChild.addEventListener("click", openPolicyModal);
  }
});

onBeforeMount(() => {
  if (link.value && link.value.firstElementChild && policyData.value) {
    link.value.firstElementChild.removeEventListener("click", openPolicyModal);
  }
});

function clearValidation(field) {
  switch (field) {
    case "name":
      errorsObj.name = null;
      break;
    case "email":
      errorsObj.email = null;
      break;
    case "accept_terms":
      errorsObj.accept_terms = null;
      break;
    case "product_id":
      errorsObj.product_id = null;
      break;
    case "phone":
      errorsObj.phone = null;
      break;
    case "email":
      errorsObj.email = null;
      break;
    case "message":
      errorsObj.message = null;
      break;

    default:
      break;
  }
}

function onVerify(token, ekey) {
  const defaultCountry = localeStore.defaultLocales.find(
    (_v) => _v.slug === store.country
  );
  form.company_id = defaultCountry ? defaultCountry.id : "";
  form.product_id = selected.value ? selected.value.id : "";
  useAPI("api/front/test-ride-inquiry", {
    method: "post",
    body: {
      ...form,
      "h-captcha-response": token,
    },
  })
    .then((response) => {
      if (response.error.value) {
        errorsObj = response.error.value.cause._data.errors;
        nuxtApp.$toast.error(response.error.value.cause._data.message);
        sending.value = false;
      } else {
        nuxtApp.$toast.success(t("common.test_ride_inquiry.thanks"));
        form = Object.assign({}, formFields);
        sending.value = false;

        window._iub.cons_instructions.push([
          "submit",
          {
            writeOnLocalStorage: false,
            form: {
              selector: document.getElementById("test_ride_form"),
            },
            consent: {
              legal_notices: [
                {
                  identifier: "privacy_policy",
                },
                {
                  identifier: "cookie_policy",
                },
                {
                  identifier: "term",
                },
              ],
            },
          },
          {
            success(response) {
              // console.log(response)
            },
            error(response) {
              console.warning(response);
            },
          },
        ]);
      }
    })
    .catch((error) => {
      console.error(error);
      sending.value = false;
    });
}

function onChangeCountry(event) {
  if (event) {
    form.country_code = event.id;
    form.country_name = event.name;
  }
}

function onExpire() {
  nuxtApp.$toast.error("Captcha expired");
  console.log("[vue-htcapcha] Expired token");
  sending.value = false;
}

function onError() {
  console.log("[vue-htcapcha] Failed to load hcaptcha");
  sending.value = false;
}

function onSubmit() {
  if (sending.value) {
    return;
  }

  sending.value = true;
  errorsObj.value = {};

  invisibleHcaptcha.value.execute();
}

const { open, close } = useModal({
  component: PrivacyPolicyTestDriveModal,
  attrs: {
    policyData: policyData.value,
  },
});
const openPolicyModal = open;
</script>

<style lang="postcss">
@import "vue-tel-input/vue-tel-input.css";

.test-drive-hero-bg-section {
  background-image: linear-gradient(
      259deg,
      rgba(0, 0, 0, 0) 30.42%,
      rgba(0, 0, 0, 0.74) 55.5%,
      rgba(0, 0, 0, 0.9) 98.83%
    ),
    url("@/assets/images/test-drive/test-drive-banner-img.png");

  background-repeat: no-repeat;
  background-position: center center;
  @apply md:bg-cover;
}

.test-drive--checkbox {
  .test_drive__checkmark {
    height: 17px;
    width: 17px;
    top: 0.2rem;
    left: 0;
    border-radius: 5px;

    &::after {
      content: "";

      @apply absolute hidden;
      top: 3px;
      left: 6px;
      width: 5px;
      height: 10px;
      border: solid white;
      border-width: 0 3px 3px 0;
      -webkit-transform: rotate(45deg);
      -ms-transform: rotate(45deg);
      transform: rotate(45deg);
    }
  }
}

.test-ride #phone {
  @apply h-12 w-full border-[#DBDBDB] border-opacity-30 opacity-100 rounded-[10px] text-white placeholder-current !important;
}
.test-ride select[disabled] {
  @apply text-white text-opacity-40;
}
.test-ride .vs__dropdown-toggle {
  @apply w-full px-4 py-3 border-gray-300 rounded-md shadow-sm;
}

.test-ride .terms a {
  @apply text-white;
}

q .test-ride .vue-tel-input:focus-within {
  @apply shadow-none;
}

.test-ride .vti__dropdown:focus,
.test-ride .vti__input:focus {
  @apply ring-primary-500 border-primary-500 border-2;
}

.test-ride .vti__input {
  @apply border-[#f1d4b5] bg-[#FFFFFF] text-sm bg-opacity-10 text-white !important;
}

.test-ride .vue-tel-input:placeholder {
  @apply text-white;
}

.test-ride .vti__dropdown {
  @apply rounded-e-none rounded-md border-[#f1d4b5] border-r border-opacity-30 bg-white bg-opacity-10 outline-none !important;
}

.test-ride .vti__dropdown-list {
  @apply text-black bg-white !important;
}
/* .test-ride select {
  @apply text-white text-opacity-70;
} */
.test-ride option[value=""][disabled] {
  @apply hidden;
}

.test-ride .vue-select-chooser .vs__search::placeholder {
  @apply text-white text-opacity-70;
}
.test-ride .vue-select-chooser .vs__search::placeholder,
.test-ride .vue-select-chooser .vs__dropdown-toggle,
.test-ride .vue-select-chooser .vs__dropdown-menu {
  @apply mt-2 w-full rounded-[10px] text-sm border-[#f1d4b5] border  border-opacity-30 font-ff-good-pro-cond font-normal;
}

.test-ride .vue-select-chooser .vs__dropdown-toggle {
  @apply bg-opacity-10 bg-white text-white h-[48px];
}

.test-ride
  .vue-select-chooser
  .vs__dropdown-toggle
  .vs__selected-options
  .vs__selected {
  color: white;
  opacity: 0.7;
}

.test-ride .vue-select-chooser .vs__dropdown-toggle:focus:focus {
  @apply focus:ring-primary-500 focus:border-primary-500 border-2;
}

.test-drive-info p,
h1,
h2,
h3,
h4,
h5,
h6,
strong,
ul {
  @apply my-4;
}
.test-drive-info h1,
h2,
h3,
h4,
h5,
h6 {
  @apply font-bold;
}
.test-drive-info ul {
  @apply list-disc pl-10;
}
.test-ride ::placeholder {
  @apply !text-white !text-opacity-70;
}
</style>
